import loadable from "@loadable/component";
import { FC } from "react";
import { UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/Endpoint";
import useFormdataPatchHook from "../../customHooks/useFormdataPatchHook";
import useGetHook from "../../customHooks/useGetHook";
import { IPostSchema } from "../../utils/validationSchema";

const EditPostComponent = loadable(
  () => import("../../components/Posts/EditPost") as unknown as Promise<FC>
);

export const EditPost = () => {
  const { id } = useParams();

  const { data, isLoading } = useGetHook({
    queryKey: [`blog-${id}`],
    url: `${APIS.BLOG_STATUS}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } =
    useFormdataPatchHook<IPostSchema>({
      queryKey: [`update-blog-${id}`],
      navigateURL: "/blog/post",
    });

  const handleEdit = async (
    data: IPostSchema,
    setError: UseFormSetError<IPostSchema>
  ) => {
    const tag = data.tag.map((d) => d.value);
    const category = data.category.map((d) => d.value);
    const file = data.preview_image as File;
    delete data.preview_image;
    delete data.tag;
    delete data.category;
    const url = `${APIS.BLOG_STATUS}${id}/`;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      switch (typeof data[key]) {
        case "string":
        case "number":
        case "boolean":
          if (!data[key]) break;
          formData.append(key, data[key]);
          break;
        default:
          if (!data[key]) break;
          formData.append(key, JSON.stringify(data[key]));
      }
    });
    if (file instanceof File) formData.append("preview_image", file);
    formData.append("tag", JSON.stringify(tag));
    formData.append("category", JSON.stringify(category));
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <EditPostComponent
        /*@ts-ignore */
        data={data}
        handleEdit={handleEdit}
        isLoading={isPatchLoading}
      />
    </>
  );
};
